export default __webpack_public_path__ + "static/media/QR Code - Grupos de Ofertas.16079b6c.png";